import { MenuIntemInterface } from './interfaces/menu-item.interface';
import { MenuCollapseInterface } from './interfaces/menu-collapse.interface';
import { MenuGroupInterface } from './interfaces/menu-group.interface';

export class AppNavigationModel {
  public model: MenuGroupInterface[] | MenuCollapseInterface[] | MenuIntemInterface[];

  constructor() {
    this.model = [
      {
        'id': 'applications',
        'title': 'Applications',
        'translate': 'NAV.APPLICATIONS',
        'type': 'group',
        'icon': 'apps',
        'children': [
          {
            'id': 'dashboards',
            'title': 'Dashboards',
            'translate': 'NAV.CATALOGS',
            'type': 'collapse',
            'icon': 'dashboard',
             visible: false,
            'children': [
              {
                'id': 'users',
                'title': 'Users',
                'translate': 'NAV.USERS',
                'type': 'item',
                'url': '/main/users',
                'icon': 'apps',
                visible: false,
              },
              {
                'id': 'roles',
                'title': 'Roles',
                'translate': 'NAV.ROLES',
                'type': 'item',
                'url': '/main/roles',
                'icon': 'apps',
                visible: false,
              },
              {
                'id': 'locals',
                'title': 'Locals',
                'translate': 'NAV.LOCAL',
                'type': 'item',
                'url': '/main/locals',
                'icon': 'apps',
                visible: false,
              },
              {
                'id': 'productCategories',
                'title': 'ProductCategories',
                'translate': 'NAV.CATEGORY',
                'type': 'item',
                'url': '/main/productCategories',
                'icon': 'apps',
                visible: false,
              },
              {
                'id': 'products',
                'title': 'Products',
                'translate': 'NAV.PRODUCT',
                'type': 'item',
                'url': '/main/products',
                'icon': 'apps',
                visible: false,
              },
              {
                'id': 'advertisement',
                'title': 'Advertisement',
                'translate': 'NAV.ADVERTISEMENT',
                'type': 'item',
                'url': '/main/advertisement',
                'icon': 'apps',
                visible: false,
              }
            ]
          },
          {
            'id': 'load',
            'title': 'Load',
            'translate': 'NAV.LOAD',
            'type': 'collapse',
            'icon': 'dashboard',
            visible: false,
            'children': [
              {
                'id': 'loadStock',
                'title': 'LoadStock',
                'translate': 'NAV.LOADSTOCK',
                'type': 'item',
                'url': '/main/loadStock',
                'icon': 'apps',
                visible: false,
              },
              {
                'id': 'unloadStock',
                'title': 'UnloadStock',
                'translate': 'NAV.UNLOADSTOCK',
                'type': 'item',
                'url': '/main/unloadStock',
                'icon': 'apps',
                visible: false,
              }
            ]
          },
          {
            'id': 'exchanges',
            'title': 'Exchanges',
            'translate': 'NAV.EXCHANGES',
            'type': 'collapse',
            'icon': 'dashboard',
            visible: false,
            'children': [
              {
                'id': 'searchParticipant',
                'title': 'SearchPartiticpan',
                'translate': 'NAV.SEARCHPARTICIPANT',
                'type': 'item',
                'url': '/main/searchParticipant',
                'icon': 'apps',
                visible: false,
              }
            ]
          },
          {
            'id': 'reports',
            'title': 'Repors',
            'translate': 'NAV.REPORTS',
            'type': 'collapse',
            'icon': 'dashboard',
            visible: false,
            'children': [
              {
                'id': 'reportExchange',
                'title': 'ReportExchange',
                'translate': 'NAV.REPORTEXCHANGE',
                'type': 'item',
                'url': '/main/reportExchange',
                'icon': 'apps',
                visible: false,
              },
              {
                'id': 'stockMovement',
                'title': 'SotckMovement',
                'translate': 'NAV.SOTCKMOVEMENT',
                'type': 'item',
                'url': '/main/stockMovement',
                'icon': 'apps',
                visible: false,
              }
            ]
          }
        ]
      }
    ];
  }
}

